<template>
  <div class="flex flex-col gap-4">
    <section
      class="rounded-lg border border-slate-200 bg-white p-3 shadow-[0_12px_30px_rgba(15,23,42,0.06)]"
    >
      <div class="flex flex-wrap items-start justify-between gap-4">
        <div>
          <p class="text-[24px] font-black leading-8 text-slate-950">
            Câu hỏi thường gặp
          </p>
          <p
            class="mt-2 max-w-4xl text-[15px] font-medium leading-6 text-slate-600"
          >
            Tổng hợp các lỗi và thắc mắc thường gặp khi sử dụng hệ thống Zalo
            OA.
          </p>
        </div>
        <RouterLink
          to="/guide"
          class="inline-flex min-h-10 items-center gap-2 rounded-lg border border-teal-200 bg-teal-50 px-4 py-2 text-sm font-extrabold !text-teal-800 !no-underline transition hover:bg-teal-100"
          ><i class="pi pi-book"></i>Xem hướng dẫn</RouterLink
        >
      </div>
    </section>
    <section class="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <article
        v-for="group in faqGroups"
        :key="group.title"
        class="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-[0_12px_30px_rgba(15,23,42,0.06)]"
      >
        <header class="border-b border-slate-200 bg-slate-50 px-4 py-4">
          <div class="flex items-center gap-2">
            <span
              class="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-teal-100 text-teal-800"
              ><i class="pi" :class="group.icon"></i
            ></span>
            <p class="text-[17px] font-black mb-0 text-slate-950">
              {{ group.title }}
            </p>
          </div>
        </header>
        <div class="divide-y divide-slate-100">
          <details
            v-for="item in group.items"
            :key="item.question"
            class="group p-4"
          >
            <summary
              class="flex cursor-pointer list-none items-start justify-between gap-3 text-[15px] font-extrabold leading-6 text-slate-900"
            >
              <span>{{ item.question }}</span
              ><i
                class="pi pi-chevron-down ml-2 mt-1 text-xs text-slate-400 transition group-open:rotate-180"
              ></i>
            </summary>
            <p class="mt-3 font-medium leading-6 text-slate-600">
              {{ item.answer }}
            </p>
          </details>
        </div>
      </article>
    </section>
  </div>
</template>

<script lang="ts">
type FaqGroup = {
  title: string;
  icon: string;
  items: { question: string; answer: string }[];
};
export default {
  name: "FaqPage",
  setup() {
    const faqGroups: FaqGroup[] = [
      {
        title: "Đăng nhập và phân quyền",
        icon: "pi-lock",
        items: [
          {
            question: "Tôi đăng nhập không được thì kiểm tra gì trước?",
            answer:
              "Kiểm tra tên đăng nhập, mật khẩu và kết nối mạng. Nếu vẫn lỗi, liên hệ quản trị viên để kiểm tra trạng thái và quyền của tài khoản.",
          },
          {
            question: "Vì sao tôi không thấy một số menu?",
            answer:
              "Menu được hiển thị theo quyền tài khoản. Quản trị viên sẽ có nhiều chức năng hơn các tài khoản phường, quận/huyện hoặc tổ dân phố.",
          },
          {
            question: "Tại sao hệ thống tự quay về màn hình đăng nhập?",
            answer:
              "Khi phiên đăng nhập hết hạn hoặc hệ thống không còn xác thực được tài khoản, bạn cần đăng nhập lại để tiếp tục làm việc.",
          },
        ],
      },
      {
        title: "Gửi tin nhắn và hình ảnh",
        icon: "pi-send",
        items: [
          {
            question: "Nút gửi tin nhắn không hoạt động?",
            answer:
              "Hãy kiểm tra đã chọn phạm vi hoặc người nhận hợp lệ và đã nhập nội dung tin nhắn. Các trường bắt buộc cần được điền đầy đủ trước khi gửi.",
          },
          {
            question: "Tin nhắn theo mẫu cần chuẩn bị gì?",
            answer:
              "Cần có tiêu đề, nội dung và các thông tin bắt buộc của mẫu. Nếu sử dụng ảnh, hãy tải ảnh lên trước rồi dùng đường dẫn ảnh trong mẫu.",
          },
          {
            question: "Ảnh nên dùng định dạng nào?",
            answer:
              "Nên dùng JPG, JPEG hoặc PNG. Ảnh rõ nét, đúng tỷ lệ sẽ hiển thị tốt hơn trên Zalo OA.",
          },
        ],
      },
      {
        title: "Dân cư và nhóm",
        icon: "pi-users",
        items: [
          {
            question: "Import dân cư bị lỗi thì xử lý thế nào?",
            answer:
              "Kiểm tra các dòng báo lỗi, chỉnh lại dữ liệu trong tệp Excel theo mẫu rồi tải lại. Không thay đổi tên hoặc cấu trúc các cột của tệp mẫu.",
          },
          {
            question: "Xóa dân cư hoặc thành viên nhóm có cần xác nhận không?",
            answer:
              "Có. Hệ thống sẽ hiển thị hộp thoại xác nhận để hạn chế thao tác xóa nhầm.",
          },
          {
            question: "Tạo nhóm để làm gì?",
            answer:
              "Nhóm giúp gom những người nhận cố định, thuận tiện khi gửi thông báo đến cùng một đối tượng nhiều lần.",
          },
        ],
      },
      {
        title: "Góp ý, lịch trực và tài khoản",
        icon: "pi-cog",
        items: [
          {
            question: "Danh sách góp ý có thể lọc theo tiêu chí nào?",
            answer:
              "Bạn có thể lọc theo khoảng thời gian, phân loại và dùng ô tìm kiếm để tra cứu nhanh nội dung hoặc người gửi.",
          },
          {
            question: "Tra cứu danh sách khẩn cấp như thế nào?",
            answer:
              "Vào Danh sách khẩn cấp, chọn khoảng thời gian rồi bấm Làm mới danh sách. Có thể chọn nhanh Hôm nay, 7 ngày gần nhất hoặc Tháng này và tìm theo tên, số điện thoại hoặc nội dung.",
          },
          {
            question: "Làm cách nào để phân công lịch trực?",
            answer:
              "Mở Quản lý lịch trực, chọn ngày trên lịch, chọn nhân viên và lưu phân công. Bạn có thể xóa phân công khi cần điều chỉnh.",
          },
          {
            question: "Tôi có thể tự tạo hoặc sửa tài khoản không?",
            answer:
              "Các chức năng đăng ký và quản lý tài khoản dành cho quản trị viên. Quyền của tài khoản quyết định các thao tác có thể thực hiện.",
          },
        ],
      },
    ];
    return { faqGroups };
  },
};
</script>
